import React, { useState, useEffect } from "react";
import TextField from "../../../components/inputs/textfield";
import ResourseTile from "../../../components/page/tiles/resourse";
import "./style.css";
import { expertManPowerList } from "../user.api";
import Loader from "../../../components/loader/loader";
import BreadCrumpBack from "../../../components/navigator/back";
import { spaceParkAdvisorsList } from "../../public/public.api";
let count = 100;
export default function KSPACEAdvisors(props) {
  const [isActive, setIsActive] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const listData = () => {
    spaceParkAdvisorsList().then((res) => {
      let dir = res.data;
      setIsActive(false);
      let finalData = [];
      // dir.forEach((item) => {
      //   if (
      //     item.expert_manpower?.is_resource_person === 0 &&
      //     item.expert_manpower?.admin_status === 4
      //   ) {
      //     finalData.push(item);
      //   }
      // });

      setSearchData(dir);
      console.log(searchData);

      setIsActive(false);
    });
  };
  const [data, setData] = useState([]);
  useEffect(() => {
    listData();
  }, []);

  return (
    <div className="tender bg-tender">
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "ഉപദേഷ്ടാക്കൾ"
              : "Advisors"}
          </div>
        </div>
        <BreadCrumpBack />
      </div>
      <div className="container p-50">
        <div className="res-page-cont">
          <div className="row tender-box">
            {/* <div className="col-xs-12 col-sm-3">
              <div className="form-group has-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input type="text" className="form-control" placeholder="Search" />
              </div>
            </div> */}
            <div className="new-res-tile-cont-res">
              {searchData.length !== 0 ? (
                <div className="row">
                  {searchData?.map((item) => (
                                       <div key={item.user_id} className="col-lg-6 col-sm-12 mb-4 d-flex">
                      <div className="w-100">
                      <ResourseTile
                        data={item}
                        {...props}
                        path={`/kspace-advisors/${item?.uuid}`}
                        photo={`${result}${item?.photo}`}
                        title={`${item?.name}`}
                        email={item?.email}
                        domain={item?.domain_types}
                      />
                    </div>
                    </div>
                  ))}
                  </div>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
